import loginPageIconImport from "../assets/telawah-assets/LoginPageIcon.png";

import registerPageIconImport from "../assets/telawah-assets/quranCardIcon.svg";

export const adminPath = "komet_@dminn";
export const teachersubadminPath = "komet_te@cher";
export const domainName = "kometinstitut.online";
export const isManualPayment = true;
export const isCouponable = false;
export const isMultiYear = true;
export const isCodes = false;
export const isBtns = false;
export const isLoginTokens = false;
export const profileStatistics = false;

export const enableAutoLogin = false;

export const isFreeTrialAvailable = false;

export const isRegisterationMiddleName = false;
export const isRegisterationForthName = false;
export const isRegisterByDepartments = false;
export const isRegisterationFatherJob = false;
export const isRegisterationGender = false;

export const adminPanelColor = "yellow";
export const headerSectionColor = "yellow";
export const navbarIconColor = "text-germanRed-700";
export const navbarDisclosureColor = "germanRed";
export const isCenters = false;
export const isCourseLinks = false;

export const isCategories = true;
export const isCollapseCategories = true;
export const isCoursesRenamed = false;
export const isSectionRenamed = false;

export const progressBarColor = "germanRed";
export const loadingBarColor = "sky";

export const isBunny = false;

export const isPlatformSubscription = false;
export const isTimedManualSubscription = false;

export const isPrepaidSystem = false;
export const prepaidInfoColor = "yellow";

export const autoChangeRandomNames = false;

export const navThemeRTL = true;

export const registerPageIcon = registerPageIconImport;
export const loginPageIcon = loginPageIconImport;
export const loginPageColor = "germanRedOffset";
export const registerPageColor = "yellow";

export const isAnalytics = false;

export const isMultiAdmin = true;

export const isSubjectSubscriptionable = true;
export const isAccountCreationRequest = false;

export const showExamStatisticsTable = false;
export const showVideoStatisticsTable = false;
export const isUserStatisticsTable = false;

export const isAdminToAdminNote = false;
export const isAdminAbleToChangeUsersYear = false;

export const isOtpEnabled = false;

export const isWalletEnabled = false;

export const isStudyPlannerEnabled = false;

export const isOnlySubscribeFromWallet = false;

export const isCenterUsers = false;

export const isForgetPassword = false;

export const isAdminUsers = false;

export const isSubscribeBySubjectTeacher = false;

export const isMigrationFromInsertAuto = false;
export const isChargeInsertAuto = false;
export const isInsertAutoTypes = false;

export const isCourseRenamedToMonthlySubscriptions = false;

export const isCommunity = true;

export const isCustomUserExamLimit = false;
export const isCustomUserVideoLimit = false;

export const isCenterApi = false;

export const isLoginAsUser = false;

export const isEssayQuestions = false;

export const isAdminCourseStatistics = false;

export const isSearch = false;

export const isPinnedCourse = false;

export const isUnassignedSubscription = false;

export const isStoreLocatorAvailable = false;

export const isYoutubeVideoButton = false;

export const isAddCenterUser = false;

export const isNavBarNotification = false;

export const isSessionReservation = false;

export const isLoggingByEmail = false;

export const isJoinUs = true;
